import { trackActions } from '../../tracking/trackingScripts'
import { TRACKED_ACTIONS } from '../actions/types'

// Sign-out resets the tracking identity in lib/currentUserSession; the user no
// longer lives in Redux, so there is no RESET_USER action to watch.
export const trackingMiddleware = (store) => (next) => (action) => {
  const { type } = action
  try {
    if (TRACKED_ACTIONS[type]) trackActions(action)
  } catch (error) {
    console.error('Unable to track Redux action:', error)
  }
  return next(action)
}
